import { useState } from "react";
import { Button, Input, Spinner } from "@fluentui/react-components";
import { Link24Regular } from "@fluentui/react-icons";

import { DocumentFingerprint, Documento } from "../../types";
import { oliDocClient } from "../../services";

interface Props {
  fingerprint: DocumentFingerprint;
  message: string;
  onBind: (documento: Documento) => void;
}

export function UnboundDocument({ fingerprint, message, onBind }: Props) {
  const [processoId, setProcessoId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleBind() {
    if (!processoId.trim()) {
      setError("Informe o ID do processo");
      return;
    }

    if (!fingerprint.file_item_id || !fingerprint.file_drive_id) {
      setError("Informações do SharePoint incompletas");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const documento = await oliDocClient.bindDocumento({
        item_id: fingerprint.file_item_id,
        drive_id: fingerprint.file_drive_id,
        ...(fingerprint.file_container_id && { container_id: fingerprint.file_container_id }),
        processo_sf_id: processoId.trim(),
      });

      onBind(documento);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Erro ao vincular documento");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="taskpane">
      {/* Warning */}
      <div className="warning-box">
        <h3>Documento não vinculado</h3>
        <p>{message}</p>
      </div>

      {/* Fingerprint info */}
      {fingerprint.file_item_id && (
        <section className="section">
          <div className="section-title">Informações do Arquivo</div>
          <div className="info-list">
            <div className="info-item">
              <span className="info-label">Item ID</span>
              <span className="info-value muted">
                {fingerprint.file_item_id.substring(0, 20)}...
              </span>
            </div>
          </div>
        </section>
      )}

      {/* Bind Form */}
      <section className="section">
        <div className="section-title">Vincular a Processo</div>

        <div className="form-group">
          <label htmlFor="processo-id">ID do Processo</label>
          <Input
            id="processo-id"
            value={processoId}
            onChange={(_, data) => setProcessoId(data.value)}
            placeholder="Ex: PROC-001"
            disabled={loading}
          />
          {error && <p className="form-error">{error}</p>}
        </div>

        <Button
          appearance="primary"
          icon={loading ? <Spinner size="tiny" /> : <Link24Regular />}
          onClick={handleBind}
          disabled={loading}
        >
          {loading ? "Vinculando..." : "Vincular Documento"}
        </Button>
      </section>

      {/* Help */}
      <div className="help-text">
        Ao vincular, o documento será registrado no Document Hub e
        receberá as propriedades de identificação.
      </div>
    </div>
  );
}
